module.exports = __webpack_public_path__ + "img/handwritten-after.d5aef10c.png";